export const CONFIRM_CONFIGURATION_PROMPT = 'CONFIRM_CONFIGURATION_PROMPT';
export const REDUCER_CONFIRM_CONFIGURATION_PROMPT = 'REDUCER_CONFIRM_CONFIGURATION_PROMPT';

export const confirmConfigurationPrompt = (limboKey: string) => ({
  type: CONFIRM_CONFIGURATION_PROMPT,
  data: {
    limboKey
  }
});
